"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoCallApi = exports.VideoCallApiFactory = exports.VideoCallApiFp = exports.VideoCallApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * VideoCallApi - axios parameter creator
 * @export
 */
const VideoCallApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Send video call
         * @param {InputSendVideoCall} [inputSendVideoCall]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVideoCall: (inputSendVideoCall, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/video-call/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputSendVideoCall, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.VideoCallApiAxiosParamCreator = VideoCallApiAxiosParamCreator;
/**
 * VideoCallApi - functional programming interface
 * @export
 */
const VideoCallApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.VideoCallApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Send video call
         * @param {InputSendVideoCall} [inputSendVideoCall]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVideoCall(inputSendVideoCall, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendVideoCall(inputSendVideoCall, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.VideoCallApiFp = VideoCallApiFp;
/**
 * VideoCallApi - factory interface
 * @export
 */
const VideoCallApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.VideoCallApiFp)(configuration);
    return {
        /**
         *
         * @summary Send video call
         * @param {InputSendVideoCall} [inputSendVideoCall]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVideoCall(inputSendVideoCall, options) {
            return localVarFp.sendVideoCall(inputSendVideoCall, options).then((request) => request(axios, basePath));
        },
    };
};
exports.VideoCallApiFactory = VideoCallApiFactory;
/**
 * VideoCallApi - object-oriented interface
 * @export
 * @class VideoCallApi
 * @extends {BaseAPI}
 */
class VideoCallApi extends base_1.BaseAPI {
    /**
     *
     * @summary Send video call
     * @param {InputSendVideoCall} [inputSendVideoCall]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoCallApi
     */
    sendVideoCall(inputSendVideoCall, options) {
        return (0, exports.VideoCallApiFp)(this.configuration).sendVideoCall(inputSendVideoCall, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VideoCallApi = VideoCallApi;
